import React, { useState } from 'react';
import { CustomCalendar } from '../../Common/CustomCalendar';

interface ProductSKU {
    id: string;
    skuUnit: string;
    cases: string;
    topMin: string;
    min: string;
    max: string;
    topMax: string;
}

export const NewTarget: React.FC = () => {
    const [targetPeriod, setTargetPeriod] = useState('Custom');
    const [targetYear, setTargetYear] = useState('2026');
    const [targetAmount, setTargetAmount] = useState('0');
    const [startDate, setStartDate] = useState('2026-03-28');
    const [skuSearch, setSkuSearch] = useState('');

    // Mock products data list matching mockup exactly
    const [skus, setSkus] = useState<ProductSKU[]>([
        { id: '1', skuUnit: 'GOW. Gold Cow Milk 6000ML', cases: '0', topMin: '0', min: '0', max: '0', topMax: '0' },
        { id: '2', skuUnit: 'GOW. Gold Cow Milk 500ml', cases: '0', topMin: '0', min: '0', max: '0', topMax: '0' },
        { id: '3', skuUnit: 'Cow Fresh Toned Milk 6000ML', cases: '0', topMin: '0', min: '0', max: '0', topMax: '0' },
        { id: '4', skuUnit: 'Gowardhan Pure Ghee 1L Jar', cases: '0', topMin: '0', min: '0', max: '0', topMax: '0' },
        { id: '5', skuUnit: 'GOW. Fresh Paneer 200g Block', cases: '0', topMin: '0', min: '0', max: '0', topMax: '0' },
    ]);

    // Update integer fields locally
    const handleInputChange = (id: string, field: keyof ProductSKU, val: string) => {
        setSkus(prev => prev.map(item => {
            if (item.id === id) {
                return { ...item, [field]: val };
            }
            return item;
        }));
    };

    const filteredSkus = skus.filter(sku => 
        sku.skuUnit.toLowerCase().includes(skuSearch.toLowerCase())
    );

    return (
        <div className="space-y-6">
            
            {/* CARD 1: Set Outlet Target Filter Panel */}
            <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
                
                {/* Header Row */}
                <div className="flex items-center justify-between border-b border-slate-100 pb-2">
                    <span className="text-sm font-bold text-[#1F1F1F] select-none">
                        Set Outlet Target
                    </span>
                    {/* Down Arrow / Collapse Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-[#1F1F1F] cursor-pointer">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>

                {/* Filters Grid - 4 columns */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    
                    {/* Select Target Period 1 */}
                    <div className="space-y-1">
                        <label className="text-[11px] font-bold text-slate-800 block select-none">
                            Select Target Period
                        </label>
                        <div className="relative">
                            <select
                                value={targetPeriod}
                                onChange={(e) => setTargetPeriod(e.target.value)}
                                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-xs text-[#1F1F1F] font-semibold focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none cursor-pointer appearance-none"
                            >
                                <option value="Custom">Custom</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Quarterly">Quarterly</option>
                                <option value="Yearly">Yearly</option>
                            </select>
                            {/* Dropdown Chevron Icon */}
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-slate-600">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* Select Target Period 2 (Year) */}
                    <div className="space-y-1">
                        <label className="text-[11px] font-bold text-slate-800 block select-none">
                            Select Target Period
                        </label>
                        <div className="relative">
                            <select
                                value={targetYear}
                                onChange={(e) => setTargetYear(e.target.value)}
                                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-xs text-[#1F1F1F] font-semibold focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none cursor-pointer appearance-none"
                            >
                                <option value="2026">2026</option>
                                <option value="2027">2027</option>
                                <option value="2028">2028</option>
                            </select>
                            {/* Dropdown Chevron Icon */}
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-slate-600">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* Collection Amount */}
                    <div className="space-y-1">
                        <label className="text-[11px] font-bold text-slate-800 block select-none">
                            Collection Amount
                        </label>
                        <input
                            type="number"
                            value={targetAmount}
                            onChange={(e) => setTargetAmount(e.target.value)}
                            placeholder="e.g. 50000"
                            className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-xs text-[#1F1F1F] font-semibold focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                        />
                    </div>

                    {/* Start Date */}
                    <CustomCalendar
                        label="Start Date"
                        value={startDate}
                        onChange={(val) => setStartDate(val)}
                    />

                </div>

                {/* Action Buttons row (Update only) */}
                <div className="flex items-center justify-center pt-2">
                    <button
                        className="px-6 py-2.5 bg-[#5D4037] hover:bg-[#4E342E] text-white font-bold text-xs rounded-xl cursor-pointer flex items-center gap-1.5 shadow-sm transition-all select-none"
                    >
                        {/* Sync SVG */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6.18165 1.58557C6.53316 1.58557 6.81826 1.87079 6.81837 2.22229C6.81837 2.57388 6.53323 2.859 6.18165 2.859H3.80665C2.40449 2.8625 1.27054 4.00179 1.27345 5.40393L0.424814 5.40588H0.636728L1.27345 5.40393V10.1813L1.28614 10.441C1.41338 11.7216 2.49206 12.7229 3.80665 12.7262H8.55763C9.8721 12.7228 10.9509 11.7216 11.0781 10.441L11.0908 10.1813V6.9967C11.091 6.64521 11.3761 6.35998 11.7275 6.35998C12.0789 6.36013 12.3641 6.6453 12.3643 6.9967V10.1783L12.3594 10.3746C12.2617 12.3891 10.6001 13.9945 8.56056 13.9996L8.5586 13.0035V13.3629L8.56056 13.9996H3.80372L3.80567 13.3629V13.0035L3.80372 13.9996C1.69839 13.9945 -0.00449816 12.2837 8.92619e-06 10.1783V5.40588C-0.00393784 3.30097 1.69873 1.59068 3.80372 1.58557L3.80567 2.24182V2.22229L3.80372 1.58557H6.18165ZM9.35157 10.3395C9.70306 10.3395 9.98824 10.6246 9.98829 10.9762C9.98829 11.3277 9.70309 11.6128 9.35157 11.6129H3.01368C2.6621 11.6129 2.37696 11.3278 2.37696 10.9762C2.37701 10.6246 2.66213 10.3395 3.01368 10.3395H9.35157ZM9.53419 0.51916C9.93724 0.0123025 10.6353 -0.141615 11.209 0.138301L11.3242 0.201778L11.3887 0.2467L12.7178 1.30529L12.7578 1.33947C13.0145 1.5812 13.159 1.91912 13.1572 2.27209C13.1555 2.5997 13.0259 2.91157 12.7998 3.14611L11.794 4.34924V4.35021L8.35645 8.44885L8.34864 8.45959C8.20162 8.62764 8.00511 8.74564 7.78712 8.79748L7.78028 8.79943L5.99806 9.20373C5.96256 9.21174 5.92599 9.21653 5.88966 9.21838C5.3244 9.24648 4.83185 8.8353 4.7588 8.27404C4.75527 8.24687 4.75294 8.21941 4.75294 8.19201V6.35998C4.75295 6.34567 4.75392 6.33129 4.75489 6.31701C4.77065 6.08618 4.86318 5.86662 5.01856 5.69494L8.38673 1.88732L9.53321 0.517207L9.53419 0.51916ZM6.02638 6.47814V7.89123L7.4297 7.57287L10.0547 4.44104C9.76058 4.32053 9.50145 4.1495 9.28321 3.95959C9.08099 3.78365 8.90605 3.58664 8.75782 3.3883L6.02638 6.47814ZM10.6455 1.28186C10.6041 1.2647 10.5552 1.27564 10.5274 1.31213C10.5216 1.31963 10.5158 1.32735 10.5098 1.33459L9.62306 2.39221C9.747 2.59725 9.91409 2.8202 10.1191 2.99865C10.3802 3.22578 10.6623 3.35291 10.9785 3.3385L11.8272 2.32385C11.8439 2.30378 11.8627 2.28506 11.8818 2.26721L10.6455 1.28186Z" fill="white" />
                        </svg>
                        Update
                    </button>
                </div>

            </div>

            {/* CARD 2: Products SKU Inputs Grid */}
            <div className="bg-white rounded-3xl border border-[#ECECF2] px-4 py-3 shadow-sm space-y-4">
                
                {/* Header Title & Search SKU */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <span className="text-sm font-bold text-[#1F1F1F] select-none">
                        Products
                    </span>
                    
                    {/* Search Field */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search SKU"
                            value={skuSearch}
                            onChange={(e) => setSkuSearch(e.target.value)}
                            className="bg-white border border-slate-200 rounded-full px-4 py-1 text-xs outline-none focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] w-48 font-medium placeholder-slate-400"
                        />
                    </div>
                </div>

                {/* Table Layout */}
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse min-w-[900px]">
                        <thead>
                            <tr className="border-b border-slate-100 text-[10px] font-bold text-slate-400 select-none uppercase tracking-wider">
                                <th className="py-3 px-4 w-72">SKU Unit</th>
                                <th className="py-3 px-4 text-center">Cases</th>
                                <th className="py-3 px-4 text-center">Top Min (Cases)</th>
                                <th className="py-3 px-4 text-center">Min (Cases)</th>
                                <th className="py-3 px-4 text-center">Max (Cases)</th>
                                <th className="py-3 px-4 text-center">Top Max (Cases)</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-50">
                            {filteredSkus.map((sku) => (
                                <tr key={sku.id} className="hover:bg-slate-50/30 transition-colors">
                                    {/* SKU Unit Name */}
                                    <td className="py-3.5 px-4 text-xs font-semibold text-[#1F1F1F] truncate max-w-xs">
                                        {sku.skuUnit}
                                    </td>
                                    
                                    {/* Cases Input */}
                                    <td className="py-3.5 px-4 text-center">
                                        <input
                                            type="text"
                                            value={sku.cases}
                                            onChange={(e) => handleInputChange(sku.id, 'cases', e.target.value)}
                                            className="w-24 bg-white border border-slate-200 rounded-xl px-3 py-1.5 text-xs text-[#1F1F1F] font-semibold text-center focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                                        />
                                    </td>
                                    
                                    {/* Top Min Input */}
                                    <td className="py-3.5 px-4 text-center">
                                        <input
                                            type="text"
                                            value={sku.topMin}
                                            onChange={(e) => handleInputChange(sku.id, 'topMin', e.target.value)}
                                            className="w-24 bg-white border border-slate-200 rounded-xl px-3 py-1.5 text-xs text-[#1F1F1F] font-semibold text-center focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                                        />
                                    </td>
                                    
                                    {/* Min Input */}
                                    <td className="py-3.5 px-4 text-center">
                                        <input
                                            type="text"
                                            value={sku.min}
                                            onChange={(e) => handleInputChange(sku.id, 'min', e.target.value)}
                                            className="w-24 bg-white border border-slate-200 rounded-xl px-3 py-1.5 text-xs text-[#1F1F1F] font-semibold text-center focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                                        />
                                    </td>
                                    
                                    {/* Max Input */}
                                    <td className="py-3.5 px-4 text-center">
                                        <input
                                            type="text"
                                            value={sku.max}
                                            onChange={(e) => handleInputChange(sku.id, 'max', e.target.value)}
                                            className="w-24 bg-white border border-slate-200 rounded-xl px-3 py-1.5 text-xs text-[#1F1F1F] font-semibold text-center focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                                        />
                                    </td>
                                    
                                    {/* Top Max Input */}
                                    <td className="py-3.5 px-4 text-center">
                                        <input
                                            type="text"
                                            value={sku.topMax}
                                            onChange={(e) => handleInputChange(sku.id, 'topMax', e.target.value)}
                                            className="w-24 bg-white border border-slate-200 rounded-xl px-3 py-1.5 text-xs text-[#1F1F1F] font-semibold text-center focus:ring-2 focus:ring-[#5D4037]/20 focus:border-[#5D4037] outline-none"
                                        />
                                    </td>
                                </tr>
                            ))}
                            {filteredSkus.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="py-8 text-center text-xs font-semibold text-slate-400">
                                        No SKUs found matching your search.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>

        </div>
    );
};

export default NewTarget;
